import React, { useState, useEffect } from 'react';
import { buildAvatarUrlClient } from '@/lib/avatarClient';
import type { NewNotificationData } from '@/lib/websocketService';

interface NotificationToastContentProps {
  wsNotification: NewNotificationData;
}

export function NotificationToastContent({ wsNotification }: NotificationToastContentProps) {
  const [timeAgo, setTimeAgo] = useState('');

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const date = new Date(wsNotification.created_at * 1000);
      const diff = now.getTime() - date.getTime();
      const seconds = Math.floor(diff / 1000);
      if (seconds < 60) return `${seconds}s ago`;
      const minutes = Math.floor(seconds / 60);
      if (minutes < 60) return `${minutes}m ago`;
      const hours = Math.floor(minutes / 60);
      if (hours < 24) return `${hours}h ago`;
      const days = Math.floor(hours / 24);
      return `${days}d ago`;
    };

    setTimeAgo(updateTime());
    const interval = setInterval(() => {
      setTimeAgo(updateTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [wsNotification.created_at]);

  const avatarUrl = buildAvatarUrlClient(wsNotification.actor_avatar_key) ||
    `https://ui-avatars.com/api/?name=${wsNotification.actor_username}&size=32&background=1f2937&color=ffffff&bold=true`;

  return (
    <div className="flex items-start space-x-3 w-full">
      <img
        src={avatarUrl}
        alt={wsNotification.actor_username}
        className="w-8 h-8 rounded-full cursor-pointer"
        onClick={() => window.location.href = `/profile/${wsNotification.actor_username}`}
      />
      <div className="flex-1">
        <p className="text-sm text-zinc-100">{wsNotification.message_summary}</p>
        <p className="text-xs text-zinc-400">{timeAgo}</p>
        <div className="flex space-x-2 mt-2">
          <button
            className="text-xs text-blue-400 hover:text-blue-300"
            onClick={() => window.location.href = wsNotification.link_target_url || '/notifications'}
          >
            View
          </button>
          {['comment', 'message', 'mention'].includes(wsNotification.notification_type) && (
            <button
              className="text-xs text-green-400 hover:text-green-300"
              onClick={() => window.location.href = (wsNotification.link_target_url || '/notifications') + '?reply='}
            >
              Reply
            </button>
          )}
        </div>
      </div>
    </div>
  );
}